import packageInfo from '../../package.json';

export const environment = {
  version: packageInfo.version + '-dev',
  production: false,
  url_api: 'https://dev.chat.colossus.digital:3001/api/v1',
};
